export default __webpack_public_path__ + "static/media/tashkent3.a4008ab8.jpg";